import { createRoot } from 'react-dom/client';

import App from './app/App';
import './index.css';
import './styles/oprk-tokens.css';
import './styles/image-zoom.css';

createRoot(document.getElementById('root')!).render(<App />);
